interface ConnectionStatusBadgeProps {
  isConnected: boolean;
  label?: string;
  className?: string;
}

/**
 * Connection Status Badge Component
 * Displays "WS Connected" or "WS Disconnected" with appropriate styling
 */
export default function ConnectionStatusBadge({
  isConnected,
  label,
  className = "",
}: ConnectionStatusBadgeProps) {
  return (
    <span
      className={`hooks-test-status-badge ${
        isConnected
          ? "hooks-test-status-badge-connected"
          : "hooks-test-status-badge-disconnected"
      } ${className}`}
    >
      {label || (isConnected ? "WS Connected" : "WS Disconnected")}
    </span>
  );
}
